const emailRegex = /^(?=.{5,254}$)(^[^\s@]{1,64})+@[^\s@]+\.[^\s@]+$/; // NOSONAR
const nameRegex = /^([a-zA-ZÀ-ÖØ-öø-ÿ\u0101\u0113\u012b\u014d\u016b\u0100\u0112\u012a\u014c\u016a]+\.?-?\s?'?-?)+$/; // NOSONAR
const nzMobilePhoneRegex = /^((020|021|022|025|027|028|029)\d{6,8})$/; // NOSONAR
const nzPhoneRegex = /^((03|04|06|07|09)\d{7})|((020|021|022|025|027|028|029)\d{6,8})|((0508|0800|0900)\d{5,8})$/; // NOSONAR
const passwordRegex = /^(?=.{8,})(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{8,256}$/;
const urlRegex = /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/; // NOSONAR
const usernameRegex = /^[a-zA-Z@!#$%&'*+\-/.=?^_`{|}~;\d]{4,256}$/; // NOSONAR

export {
  emailRegex,
  nameRegex,
  nzMobilePhoneRegex,
  nzPhoneRegex,
  passwordRegex,
  urlRegex,
  usernameRegex
};
